import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class ReceiptService {
  getReceipt(order) {
    return RetailerApiClient.get('orders/' + order + '/receipt')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
